import { useStore } from "vuex"
import GroupDetails from "../GroupDetails/GroupDetails.vue"
import ThemeCard from "../ThemeCard/ThemeCard.vue"
import SpotCard from '../SpotCard/SpotCard.vue'
import { computed, onMounted, ref } from "vue"

export default {
    name: "ActiveGroups",
    components: {
        GroupDetails,
        ThemeCard,
        SpotCard
    },
    props: {
        guid: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        const groups = computed(() => store.state.search.results[props.guid])
        const isSearching = computed(() => store.state.search.is_searching)
        const showNotMemberComponents = computed(() => !isSearching.value && store.state.search.results[props.guid]?.length === 0)

        onMounted(async () => {

            isSearching.value = true
            
            await store.dispatch('search/initSearchScope', {
                guid: props.guid,
                firstPageSize: 1000,
                showMorePageSize: 1000,
                url: process.env.COMMUNITY_GET_USER_GROUPS.replace('[pageId]', store.state.main.page_id)
            })
            
            await store.dispatch('search/performSearch', {
                guid: props.guid,
                query: '',
                skip: 0,
                take: 1000
            })

            isSearching.value = false
        })

        return {
            groups,
            isSearching,
            showNotMemberComponents,
            getLabel: (labelKey) => store.getters['labels/getLabel']({labelCollection: "ActiveGroups", labelKey: labelKey})
        }
    }
}